module.exports = __webpack_public_path__ + "img/premium.703f2592.png";